const LOCATION_TYPES_DICT = {
  loss_location: 'Loss Location',
  vehicle_location: 'Vehicle Location',
  checks_address: 'Checks Address',
  physical_mail_address: 'Physical Mail Address',
} as const;

export default LOCATION_TYPES_DICT;
